module.exports = __webpack_public_path__ + "static/media/picture8.9961db8b.png";